import React from 'react';
import { Button, Col, Form, Row } from 'react-bootstrap';

import { Formik } from 'formik';
import * as Yup from 'yup';

import { capacityApi } from '@reducers/capacity';

export const CreateTrunkForm = () => {
  const [createQuery] = capacityApi.useCreateUserTrunkMutation();

  const schema = Yup.object({
    name: Yup.string().required(),
    type: Yup.string().required(),
    prefix: Yup.string().optional(),
  });

  const onSubmit = async (values, actions) => {
    actions.setSubmitting(true);
    createQuery({ data: values })
      .unwrap()
      .catch(() => {
        actions.setFieldError('name', 'Server-side error occurred.');
        actions.setSubmitting(false);
      });
  };
  return (
    <Formik
      enableReinitialize
      validationSchema={schema}
      initialValues={{ name: '', type: '1', prefix: '' }}
      onSubmit={onSubmit}
    >
      {({
        handleSubmit,
        handleChange,
        handleBlur,
        values,
        touched,
        errors,
      }) => (
        <Form onSubmit={handleSubmit}>
          <Form.Group as={Row} controlId="formGroupName" className="mb-2">
            <Col md={2}>
              <Form.Label className="fw-bold">Name</Form.Label>
            </Col>
            <Col md={4}>
              <Form.Control
                name="name"
                type="input"
                size="sm"
                value={values.name}
                isValid={touched.name && !errors.name}
                isInvalid={touched.name && errors.name}
                onChange={handleChange}
                onBlur={handleBlur}
                placeholder="Name"
              />
            </Col>
          </Form.Group>
          <Form.Group as={Row} controlId="formGroupPrefix" className="mb-2">
            <Col md={2}>
              <Form.Label className="fw-bold">Prefix</Form.Label>
            </Col>
            <Col md={4}>
              <Form.Control
                name="prefix"
                type="input"
                size="sm"
                value={values.prefix}
                isValid={touched.prefix && !errors.prefix}
                isInvalid={touched.prefix && errors.prefix}
                onChange={handleChange}
                onBlur={handleBlur}
                placeholder="0.0.0.0"
              />
            </Col>
          </Form.Group>
          <Form.Group as={Row} controlId="formGroupType" className="mb-2">
            <Col md={2}>
              <Form.Label className="fw-bold">Type</Form.Label>
            </Col>
            <Col md={4}>
              <Form.Select
                name="type"
                type="input"
                size="sm"
                value={values.type}
                isValid={touched.type && !errors.type}
                isInvalid={touched.type && errors.type}
                onChange={handleChange}
                onBlur={handleBlur}
              >
                <option value="1">Inbound</option>
                <option value="2">Outbound</option>
              </Form.Select>
            </Col>
          </Form.Group>
          <Button
            variant="didxl"
            size="sm"
            type="submit"
            onClick={handleSubmit}
          >
            Save
          </Button>
        </Form>
      )}
    </Formik>
  );
};
